// ---------------------------------------------
// modules/pmiLogging-module/index.ts
// ---------------------------------------------

import { AbacoWebModule, RouterReadyEvent, VueRouter, MenuItem } from "@abaco/web-common/src/app";
import Vue from "vue";
import { HTTPClient } from "@abaco/web-common/src/HTTP";

import { createMenu } from "./menu";
import globals from "./globals";
import myRoutes from "./routes";
import CruscottoLoggingApplicativoVuexModule from "./state";
import CruscottoLoggingApplicativoApi from "./api/api";

export const MODULE_ID = "cruscotto_logging_applicativo_module";

export default class CruscottoLoggingApplicativoModule implements AbacoWebModule {
  public static MODULE_ID = MODULE_ID;
  readonly id = MODULE_ID;
  readonly routes = myRoutes;
  readonly globalComponents = globals;
  readonly vuexModule = new CruscottoLoggingApplicativoVuexModule();

  private router!: VueRouter;
  private evnBus = new Vue();
  private apiCreated = false;
  private cruscottoLoggingApplicativoApi!: CruscottoLoggingApplicativoApi;

  get eventBus() {
    return this.evnBus;
  }

  menu: MenuItem[] = [];

  onRouterReady(evt: RouterReadyEvent) {
    this.router = evt.router;
    this.menu = createMenu(this.router);
  }

  async beforeEnterAnyRoutes(http: HTTPClient) {
    if (this.apiCreated) return;
    this.apiCreated = true;
    this.cruscottoLoggingApplicativoApi = new CruscottoLoggingApplicativoApi(http);
  }

  public get CruscottoLoggingApplicativoApi() {
    return this.cruscottoLoggingApplicativoApi;
  }

  getMenu(): MenuItem[] {
    return this.menu;
  }
}
